export default __webpack_public_path__ + "static/backstagesupport-48-ebb291e8b6f1d6edd94815c238b36220.png";